module.exports = __webpack_public_path__ + "static/media/Reports.52f5cec5.svg";